<template>
<div>
  <a v-if="type" key="normalbutton" class="btn"  :class="color"   :href="link">{{label}}</a>
  <router-link v-if="!type"  key="routerbutton" class="btn" :class="color" :to="link">{{label}}</router-link>
</div>
</template>


<script>
  export default {
    props: {
      label : String,
      link: String,
      color: String,
      type: Boolean,
      arrow: String
    }
  }

</script>

<style>
.btn{
    font-family: Montserrat;
    font-size: 1.1rem;
    font-weight: 600;
    display: inline-block;
    text-align: center;
    text-decoration: none;
    margin: 2px 0;
    border: solid 1px transparent;
    border-radius: 3.36rem;
    padding: 1.5rem 2.2rem;
    color: #ffffff;
  }
  .btn.right::after{
    content:"";
    position: relative;
    background: url("../assets/img/arrow_active_right.svg") no-repeat right center;
    width: 3.2px;
    height: 6.4px;
    padding-right:1.24rem;
    
  }
  .btn.left::before{
    content:"";
    position: relative;
    background: url("../assets/img/arrow_active_left.svg") no-repeat left center;
    width: 3.2px;
    height: 6.4px;
    padding-left:1.24rem;
  }
  .btn.down::after{
    content:"";
    position: relative;
    background: url("../assets/img/arrow_active_down.svg") no-repeat right center;
    width: 6.4px;
    height: 3.2px;
    padding-right:1.24rem;
  }

  .blue{
    background-color: var(--blue);
    margin: 3rem auto 0 14.6%;
    animation-name: fade;
    animation-timing-function: regular;
    animation-duration: 0.2s;
    animation-delay: 1.2s;
    animation-fill-mode: backwards;
  }

  .blue:hover{
    background-color: var(--orange);
    
  }

  .orange{
    background-color: var(--orange);
    
  }

  .orange:hover{
    background-color: var(--blue);
  }

    @media only screen and (min-width: 992px) {
      .blue{
        margin-left:0;
      }
    }
    @media only screen and (min-width: 1200px) {
    .btn{
      font-size: 1.3rem;
      padding: 1.8rem 2.5rem;
      font-weight: 600;
      line-height: 1.85;
    }
    .blue{
      margin-top:0;
    }

  }
</style>

